import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueContentPlaceholders from "vue-content-placeholders";
import vSelect from "vue-select";
import VueLazyLoad from "vue-lazyload";
import Sticky from "vue-sticky-directive";
import qs from "qs";
import vuescroll from "vuescroll";

import router from "./router/router";

import App from "./App.vue";
import store from "./store/store";

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(VueContentPlaceholders);
Vue.use(VueLazyLoad);
Vue.use(Sticky);

Vue.component("v-select", vSelect);

Vue.use(vuescroll, {
  ops: {
    bar: {
      background: "#9D9C9C"
    }
  }
});

window.addEventListener("DOMContentLoaded", () => {
  let vuestore = document.getElementById('vue-store');
  if(vuestore){
    new Vue({
    router,
    store,
    render(h) {
      return h(App);
    },
    mounted() {
      const self = this;
      const routeParams = self.$route.params;
      const queryParams = qs.parse(window.location.search.substr(1));

      if(queryParams.search_term || queryParams.search_term != undefined){
        this.$store.commit('changeSearchMode', true);

        this.$store.commit("addFilter", {
          taxonomy: 'keyword',
          option: Array.isArray(queryParams.search_term) ? queryParams.search_term[0] : queryParams.search_term
        });

        delete queryParams.search_term;
      }

      if (queryParams.ws_sort) {
        this.$store.commit(
          "setSort",
          ws_vue_store.catalog_orderby_options.find(sort => sort.code === queryParams.ws_sort)
        );
        delete queryParams.ws_sort;
      } else {
        this.$store.commit("setSort", ws_vue_store.catalog_orderby_options[0]);
      }
      if (queryParams.ws_per_page) {
        this.$store.commit("changePerPage", queryParams.ws_per_page);
        delete queryParams.ws_per_page;
      }
      if (queryParams.ws_page) {
        this.$store.commit("changeCurrentPage", parseInt(queryParams.ws_page, 10));
        delete queryParams.ws_page;
      }
      Object.keys(queryParams).forEach(key => {
        if (Array.isArray(queryParams[key])) {
          queryParams[key].forEach(option => {
            this.$store.commit("addFilter", {
              taxonomy: key.replace("ws_", ""),
              option: key === "ws_product_cat" ? parseInt(option, 10) : option
            });
          });
        } else {
          this.$store.commit("addFilter", {
            taxonomy: key.replace("ws_", ""),
            option: key === "ws_product_cat" ? parseInt(queryParams[key], 10) : queryParams[key]
          });
        }
      });
      /* Attributes */
      /*this.axios
        .get(ws_vue_store.attributes_endpoint + ws_vue_store.language_code)
        .then(response => {
          if (response.data) {
            self.$store.commit("setAttributeTaxonomies", response.data.data);
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err);
        });*/
      /*****************/

      /* FEATURED PRODUCTS */
      this.axios
        .get(ws_vue_store.featured_products_endpoint + ws_vue_store.language_code + '/5')
        .then(response => {
          if (response.data) {
            self.$store.commit("setFeaturedProducts", response.data.data);
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err);
        });
      /***********************/

      this.axios
        .get(ws_vue_store.categories_endpoint + ws_vue_store.language_code)
        .then(response => {
          if (response.data.data) {
            self.$store.commit("setCategories", response.data.data);
            if (routeParams.category_slug) {
              let currentCategorySlug = routeParams.sub_category_slug != undefined ? routeParams.sub_category_slug : routeParams.category_slug;
              const matchingCategory = self.$store.state.categories.find(
                category => category.slug === currentCategorySlug
              );
              self.$store.commit("addFilter", {
                taxonomy: "product_cat",
                option: matchingCategory ? matchingCategory.term_id : undefined
              });
            }

            if ( parseInt( ws_vue_store.unchecked_first_category_by_default )  !== 1 && !self.$store.state.filters.current.product_cat && !self.$store.getters.getSearchMode) {
              const firstTopCategory = self.$store.state.categories.find(
                category => category.parent === 0
              );
              self.$store.commit("addFilter", {
                taxonomy: "product_cat",
                option: firstTopCategory ? firstTopCategory.term_id : undefined
              });
            }
            if(queryParams.ws_product_cat != undefined){
              const foundCategory = self.$store.state.categories.find(
                category => category.term_id == queryParams.ws_product_cat
              );
              if(foundCategory && foundCategory.store_attributes != undefined){
                self.$store.commit("setCategoryAllowedAttributes", foundCategory.store_attributes);
              }
            }
            self.$store.dispatch("getFilteredAttributes", []).then(() => self.$store.dispatch("getProducts", []));
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err);
        })
        .finally(() => {
          // self.$store.commit('changeLoadingState', false);
        });
    }
  }).$mount("#vue-store");
  }
});
